module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_reason03-f7ff05dd1ecf5837f6a02cc806d76a8a.png";